<template>
  <div class="container">
    <layout-container-header></layout-container-header>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'layoutContainer'
  /* mounted () {
    this.$store.dispatch('getUserInfo')
  } */
}
</script>
<style lang="scss" scoped>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: #F5F5F5;
    height: 100%;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/index.vue